export default "__VITE_PUBLIC_ASSET__538242a2__"